import { Action } from 'redux'
import { IRoom } from '../../../models/Room'
import { RoomActions } from '../../../reducers/bookingCalendar/actionNames'

const requestDeleteRoom = (roomId: string): IRequestUpdateRoom => ({
  roomId,
  type: RoomActions.RequestDeleteRoom,
})
const roomWasDeleted = (
  roomId: IRoom[keyof Pick<IRoom, 'id'>],
): IRoomWasDeleted => ({
  roomId,
  type: RoomActions.RoomWasDeleted,
})

export interface IRoomWasDeleted extends Action<RoomActions.RoomWasDeleted> {
  roomId: IRoom[keyof Pick<IRoom, 'id'>]
}

export interface IRequestUpdateRoom
  extends Action<RoomActions.RequestDeleteRoom> {
  roomId: string
}

export { roomWasDeleted }
export default requestDeleteRoom
